<template>

  <div>
    <div style="height: 50px;margin-right: 10%;margin-top: 20px">
    <el-button style="float: right" type="primary" icon="el-icon-plus" @click="save()" >添加</el-button>
    <el-dialog title="添加" :visible.sync="dialogTableVisible" :append-to-body='true' :lock-scroll="false" >
      <AddCompany></AddCompany>
    </el-dialog>
    </div>
    <div class="policyClass">
      <el-table :data="company" class="tb-edit" style="margin:0 auto">
        <el-table-column prop="tc_id" label="id" style="width:25%">
        </el-table-column>
        <el-table-column prop="tc_name" label="公司名称" style="width:25%">
        </el-table-column>
        <el-table-column  label="添加时间" style="width:25%">
          <template slot-scope="scope">
            <p v-if="scope.row.tc_addTime == null"></p>
            <p v-else>{{scope.row.tc_addTime | moment}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="tc_state" label="状态" style="width:25%">
          <template slot-scope="scope">
            <p v-if="scope.row.tc_state == 0" style="color:green;">启用</p>
            <p v-else style="color:red;">禁用</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" style="width:25%">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.tc_state"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="0"
              :inactive-value="1"
              @change="changeState($event,scope.row.tc_id)"
              style="margin-right: 10px">
            </el-switch>
            <el-button size="small" style="color:#ff0000" @click="deleteCompany(scope.row.tc_id)" >删除</el-button>
          </template>

        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import AddCompany from "./AddCompany";
  export default {
    inject:['reload'],
    components: {
      AddCompany
    },
    data(){
      return {
        rohs: true,
        rohss: false,
        dialogTableVisible: false,
        company:[]
      }
    },
    mounted(){
      this.getSelect()
    },
    methods:{
      deleteCompany(id){
        this.$inbound.post({
          interfaceId: 'company/deleteCompany',
          data:{
            tc_id:id
          },
        }).then(response => {
          this.reload()
        }).catch(error => {
          console.log(error)
        })
      },
      changeState(data,id){
        this.$inbound.post({
          interfaceId: 'company/updateCompanyState',
          data:{
            tc_id:id
          },
        }).then(response => {
          this.reload()
        }).catch(error => {
          console.log(error)
        })
      },
      getSelect(){
        this.$inbound.post({
          interfaceId: 'company/selectRowCompany',
        }).then(response => {
          this.company = response
        }).catch(error => {
          console.log(error)
        })
      },
      save(){
        // this.$router.replace({path:'/'})
      },
      save(){
        this.dialogTableVisible = true;//默认页面不显示为false,点击按钮将这个属性变成true
      },
    }
  }
</script>

<style scoped>
</style>
